export default __webpack_public_path__ + "static/404-bg-main-d8fe740a122595d5d3181dfb74dcd5de.jpg";